export const fmt = (value: number, decimals: number = 2): string => {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const formatCurrency = (value: number, decimals: number = 2): string => {
  const prefix = value >= 0 ? '' : '-';
  return `${prefix}$${fmt(Math.abs(value), decimals)}`;
};

export const formatHoldingTime = (minutes: number): string => {
  if (minutes < 60) {
    return `${minutes.toFixed(0)}m`;
  } else if (minutes < 1440) {
    const hours = minutes / 60;
    return `${hours.toFixed(1)}h`;
  } else {
    const days = minutes / 1440;
    return `${days.toFixed(1)}d`;
  }
};

/** Parse a datetime string as UTC (API returns no timezone suffix). */
export const parseUTC = (dt: string): Date =>
  new Date(dt && !dt.endsWith('Z') ? dt + 'Z' : dt);

export const formatDuration = (entryTime: string): string => {
  const entry = parseUTC(entryTime).getTime();
  const now = Date.now();
  const diffMin = (now - entry) / (1000 * 60);
  return formatHoldingTime(diffMin);
};

// Trading desk is in UTC-6 (Mexico City, no DST since 2022). Display every stored
// UTC timestamp in this zone so the UI time matches what the trader sees locally.
const DISPLAY_TZ = 'America/Mexico_City';

/** Format a UTC ISO string as HH:MM in UTC-6 (24h). */
export const formatTimeUTC6 = (iso: string | null | undefined): string => {
  if (!iso) return '-';
  try {
    return parseUTC(iso).toLocaleTimeString('en-US', {
      hour: '2-digit', minute: '2-digit', hour12: false, timeZone: DISPLAY_TZ,
    });
  } catch { return iso; }
};

/** Format a UTC ISO string as MM/DD HH:MM in UTC-6. */
export const formatDateTimeUTC6 = (iso: string | null | undefined): string => {
  if (!iso) return '-';
  try {
    const d = parseUTC(iso);
    const date = d.toLocaleDateString('en-US', {
      month: '2-digit', day: '2-digit', timeZone: DISPLAY_TZ,
    });
    const time = d.toLocaleTimeString('en-US', {
      hour: '2-digit', minute: '2-digit', hour12: false, timeZone: DISPLAY_TZ,
    });
    return `${date} ${time}`;
  } catch { return iso; }
};

/** Full date + time in UTC-6, for detail panels. */
export const formatFullDateTimeUTC6 = (iso: string | null | undefined): string => {
  if (!iso) return '-';
  try {
    return parseUTC(iso).toLocaleString('en-US', {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false, timeZone: DISPLAY_TZ,
    });
  } catch { return iso; }
};
